// Standalone full-page decision view — a shareable/bookmarkable URL for a single
// decision (/portfolio/decision/<id>), distinct from the master-detail panel at
// /portfolio/decisions. Singular path so it's a sibling of the panel under the
// portfolio layout (not a child of the panel, which renders no <Outlet/>).
// Reuses DecisionDetail (Record | Outcome | Trace).

import { Anchor, Container, Stack, Text } from "@mantine/core"
import { IconArrowLeft } from "@tabler/icons-react"
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router"

import { useDecision } from "@/hooks/useDecisionsApi"
import { DecisionDetail } from "@/pages/DecisionsPanel"

export const Route = createFileRoute("/portfolio/decision/$decisionId")({
  component: DecisionFullPage,
})

function DecisionFullPage() {
  const { decisionId } = Route.useParams()
  const navigate = useNavigate()
  const { decision, loading, error } = useDecision(decisionId)

  return (
    <Container size="xl" py="md">
      <Stack gap="lg">
        <Link to="/portfolio/decisions" style={{ fontSize: 13, color: "var(--pitch-accent)", textDecoration: "none" }}>
          <IconArrowLeft size={14} style={{ verticalAlign: "middle" }} /> All decisions
        </Link>

        {loading ? (
          <Text fz="sm" c="var(--pitch-text-tertiary)">
            Loading decision…
          </Text>
        ) : error ? (
          <Text fz="sm" c="var(--pitch-negative)">
            {error}
          </Text>
        ) : decision ? (
          <DecisionDetail decision={decision} onDeleted={() => void navigate({ to: "/portfolio/decisions" })} />
        ) : (
          <Text fz="sm" c="var(--pitch-text-tertiary)" fs="italic">
            Decision <Anchor component="span">{decisionId}</Anchor> not found.
          </Text>
        )}
      </Stack>
    </Container>
  )
}
